"use client";

import _objectSpread from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _defineProperty from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["children", "count", "overscan", "itemSize", "shift", "horizontal", "keepMounted", "reverse", "cache", "ssrCount", "item", "onScroll", "onScrollEnd", "style"],
  _excluded2 = ["children", "row", "col", "cellHeight", "cellWidth", "overscan", "initialRowCount", "initialColCount", "item", "onScroll", "onScrollEnd", "style"];
import { jsx as e } from "react/jsx-runtime";
import { useLayoutEffect as t, useEffect as n, useRef as o, memo as r, useMemo as i, forwardRef as s, useReducer as l, useImperativeHandle as c } from "react";
import { flushSync as d } from "react-dom";
var f = null,
  u = Math.min,
  a = Math.max,
  h = Math.abs,
  v = Math.floor,
  p = function p(e, t, n) {
    return u(n, a(t, e));
  },
  g = function g(e) {
    return _toConsumableArray(e).sort(function (e, t) {
      return e - t;
    });
  },
  m = "function" == typeof queueMicrotask ? queueMicrotask : function (e) {
    Promise.resolve().then(e);
  },
  _ = function _(e) {
    var t, n;
    return function () {
      return t || (t = !0, n = e()), n;
    };
  },
  w = -1,
  S = function S(e, t, n) {
    var o = n ? "unshift" : "push";
    for (var _n = 0; _n < t; _n++) e[o](w);
    return e;
  },
  $ = function $(e, t) {
    var n = e.t[t];
    return n === w ? e.o : n;
  },
  y = function y(e, t, n) {
    var o = e.t[t] === w;
    return e.t[t] = n, e.i = u(t, e.i), o;
  },
  x = function x(e, t) {
    if (!e.l) return 0;
    if (e.i >= t) return e.u[t];
    e.i < 0 && (e.u[0] = 0, e.i = 0);
    var n = e.i,
      o = e.u[n];
    for (; n < t;) o += $(e, n), e.u[++n] = o;
    return e.i = t, o;
  },
  b = function b(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e.l - 1;
    for (; n <= o;) {
      var _r = v((n + o) / 2),
        _i = x(e, _r);
      if (_i <= t) {
        if (_i + $(e, _r) > t) return _r;
        n = _r + 1;
      } else o = _r - 1;
    }
    return p(n, 0, e.l - 1);
  },
  I = function I(e, t, n) {
    var o = t - e.l;
    return e.i = n ? -1 : u(t - 1, e.i), e.l = t, o > 0 ? (S(e.u, o), S(e.t, o, n), e.o * o) : (e.u.splice(o), (n ? e.t.splice(0, -o) : e.t.splice(o)).reduce(function (t, n) {
      return t - (n === w ? e.o : n);
    }, 0));
  },
  z = "undefined" != typeof window,
  k = function k() {
    return document.documentElement;
  },
  T = function T(e) {
    return e.ownerDocument;
  },
  R = function R(e) {
    return e.defaultView;
  },
  E = /*#__PURE__*/_(function () {
    return !!z && "rtl" === getComputedStyle(k()).direction;
  }),
  M = /*#__PURE__*/_(function () {
    return /iP(hone|od|ad)/.test(navigator.userAgent);
  }),
  C = /*#__PURE__*/_(function () {
    return "scrollBehavior" in k().style;
  }),
  H = function H(e) {
    return a(e.h(), e.v());
  },
  W = function W(e) {
    return !!e.v();
  },
  O = function O(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var r = arguments.length > 4 ? arguments[4] : undefined;
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
    var s = !!o,
      l = 1,
      c = 0,
      d = 0,
      v = 0,
      p = 0,
      m = 0,
      _2 = 0,
      z = 0,
      k = 0,
      T = s ? [0, a(o - 1, 0)] : f,
      R = [0, 0],
      E = 0;
    var C = function (e, t, n) {
        return {
          o: n ? n[1] : t,
          t: n && n[0] ? S(n[0].slice(0, u(e, n[0].length)), a(0, e - n[0].length)) : S([], e),
          l: e,
          i: -1,
          u: S([], e)
        };
      }(e, t, r),
      H = new Set(),
      W = function W() {
        return v - d;
      },
      O = function O() {
        return W() + m + p;
      },
      B = function B(e) {
        return function (e, t, n, o) {
          if (o = u(o, e.l - 1), x(e, o) <= t) {
            var _r2 = b(e, t + n, o);
            return [b(e, t, o, _r2), _r2];
          }
          {
            var _r3 = b(e, t, void 0, o);
            return [_r3, b(e, t + n, _r3)];
          }
        }(C, e, c, R[0]);
      },
      _J = function J() {
        return function (e) {
          return e.l ? x(e, e.l - 1) + $(e, e.l - 1) : 0;
        }(C);
      },
      L = function L(e) {
        return x(C, e) - m;
      },
      P = function P(e) {
        return $(C, e);
      },
      A = function A(e) {
        e && (M() && 0 !== z ? m += e : p += e);
      };
    return {
      p: function p() {
        return l;
      },
      m: function m() {
        return function (e) {
          return [e.t.slice(), e.o];
        }(C);
      },
      _: function _() {
        var _R, _R2, _R3, _R4;
        var e, t;
        return _2 ? (_R = R, _R2 = _slicedToArray(_R, 2), e = _R2[0], t = _R2[1], _R) : ((_R3 = R = B(a(0, O())), _R4 = _slicedToArray(_R3, 2), e = _R4[0], t = _R4[1]), T && (e = u(e, T[0]), t = a(t, T[1]))), 1 !== z && (e -= a(0, n)), 2 !== z && (t += a(0, n)), [a(e, 0), u(t, C.l - 1)];
      },
      S: function S() {
        return b(C, O());
      },
      $: function $() {
        return b(C, O() + c);
      },
      I: function I(e) {
        return C.t[e] === w;
      },
      k: function k() {
        return !!T && C.t.slice(a(0, T[0] - 1), u(C.l - 1, T[1] + 1) + 1).includes(w);
      },
      T: L,
      R: P,
      M: function M() {
        return C.l;
      },
      C: function C() {
        return v;
      },
      H: function H() {
        return 0 !== z;
      },
      v: function v() {
        return c;
      },
      W: function W() {
        return d;
      },
      h: _J,
      O: function O() {
        return _2 = p, p = 0, [_2, 2 === k || W() + c >= _J()];
      },
      B: function B(e, t) {
        var n = [e, t];
        return H.add(n), function () {
          H.delete(n);
        };
      },
      J: function J(e, t) {
        var n,
          o,
          r = 0;
        switch (e) {
          case 1:
            {
              var _e = _2;
              _2 = 0;
              var _n2 = t - v,
                _i2 = h(_n2);
              _e && _i2 < h(_e) + 1 || 0 !== k || (z = _n2 < 0 ? 2 : 1), s && (T = f, s = !1), v = t, r = 4;
              var _l = W();
              _l >= -c && _l <= _J() && (r += 1, o = _i2 > c);
              break;
            }
          case 2:
            r = 8, 0 !== z && (n = !0, r += 1), z = 0, k = 0, T = f;
            break;
          case 3:
            {
              var _e2 = t.filter(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  e = _ref2[0],
                  t = _ref2[1];
                return C.t[e] !== t;
              });
              if (!_e2.length) break;
              A(_e2.reduce(function (e, _ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                  t = _ref4[0],
                  n = _ref4[1];
                return (2 === k || (T ? !s && t < T[0] : L(t) + (0 === z && 0 === k ? P(t) : 0) < W())) && (e += n - P(t)), e;
              }, 0));
              var _iterator = _createForOfIteratorHelper(_e2),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _step$value = _slicedToArray(_step.value, 2),
                    _t = _step$value[0],
                    _n3 = _step$value[1];
                  var _e3 = P(_t),
                    _o = y(C, _t, _n3);
                  i && (E += _o ? _n3 : _n3 - _e3);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              i && c && E > c && (A(function (e, t) {
                var n = 0;
                var o = [];
                e.t.forEach(function (e, r) {
                  e !== w && (o.push(e), r < t && n++);
                }), e.i = -1;
                var r = g(o),
                  i = r.length,
                  s = i / 2 | 0,
                  l = i % 2 == 0 ? (r[s - 1] + r[s]) / 2 : r[s],
                  c = e.o;
                return ((e.o = l) - c) * a(t - n, 0);
              }(C, b(C, O()))), i = !1), r = 3, o = !0;
              break;
            }
          case 4:
            c !== t && (c = t, r = 3);
            break;
          case 5:
            t[1] ? (A(I(C, t[0], !0)), k = 2, r = 1) : (I(C, t[0]), r = 1);
            break;
          case 6:
            d = t;
            break;
          case 7:
            k = 1;
            break;
          case 8:
            T = B(t), r = 1;
        }
        r && (l = 1 + (2147483647 & l), n && m && (p += m, m = 0), H.forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            e = _ref6[0],
            t = _ref6[1];
          r & e && t(o);
        }));
      }
    };
  },
  B = setTimeout,
  J = function J(e, t) {
    return t && E() ? -e : e;
  },
  L = function L(e, t, n, o, r, i) {
    var s = Date.now;
    var l = 0,
      c = !1,
      d = !1,
      u = !1,
      a = !1;
    var h = function () {
        var t;
        var n = function n() {
            t != f && clearTimeout(t);
          },
          o = function o() {
            n(), t = B(function () {
              t = f, function () {
                if (c || d) return c = !1, void h();
                u = !1, e.J(2);
              }();
            }, 150);
          };
        return o.L = n, o;
      }(),
      v = function v() {
        l = s(), u && (a = !0), i && e.J(6, i()), e.J(1, o()), h();
      },
      p = function p(t) {
        if (c || !e.H() || t.ctrlKey) return;
        var o = s() - l;
        150 > o && 50 < o && (n ? t.deltaX : t.deltaY) && (c = !0);
      },
      g = function g() {
        d = !0, u = a = !1;
      },
      m = function m() {
        d = !1, M() && (u = !0);
      };
    return t.addEventListener("scroll", v), t.addEventListener("wheel", p, {
      passive: !0
    }), t.addEventListener("touchstart", g, {
      passive: !0
    }), t.addEventListener("touchend", m, {
      passive: !0
    }), {
      P: function P() {
        t.removeEventListener("scroll", v), t.removeEventListener("wheel", p), t.removeEventListener("touchstart", g), t.removeEventListener("touchend", m), h.L();
      },
      A: function A() {
        var _e$O = e.O(),
          _e$O2 = _slicedToArray(_e$O, 2),
          t = _e$O2[0],
          i = _e$O2[1];
        t && (r(J(t, n), i, a), a = !1, i && e.v() > e.h() && e.J(1, o()));
      }
    };
  },
  P = function P(e, t) {
    var n, o, r;
    var i = t ? "scrollLeft" : "scrollTop",
      s = t ? "overflowX" : "overflowY",
      l = /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(o, s) {
          var c, _n$scrollTo, _c, _c2, _e4, _t2, _c3, _c4, _r4, _s;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (n) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", void m(function () {
                  return l(o, s);
                }));
              case 2:
                r && r();
                c = function c() {
                  var t;
                  return [new Promise(function (n, o) {
                    t = n, r = o, W(e) && B(o, 150);
                  }), e.B(2, function () {
                    t && t();
                  })];
                };
                if (!(s && C())) {
                  _context.next = 23;
                  break;
                }
              case 5:
                if (!(e.J(8, o()), e.k())) {
                  _context.next = 20;
                  break;
                }
                _c = c(), _c2 = _slicedToArray(_c, 2), _e4 = _c2[0], _t2 = _c2[1];
                _context.prev = 7;
                _context.next = 10;
                return _e4;
              case 10:
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](7);
                return _context.abrupt("return");
              case 15:
                _context.prev = 15;
                _t2();
                return _context.finish(15);
              case 18:
                _context.next = 5;
                break;
              case 20:
                n.scrollTo((_n$scrollTo = {}, _defineProperty(_n$scrollTo, t ? "left" : "top", J(o(), t)), _defineProperty(_n$scrollTo, "behavior", "smooth"), _n$scrollTo));
                _context.next = 39;
                break;
              case 23:
                _c3 = c(), _c4 = _slicedToArray(_c3, 2), _r4 = _c4[0], _s = _c4[1];
                _context.prev = 24;
                n[i] = J(o(), t);
                e.J(7);
                _context.next = 29;
                return _r4;
              case 29:
                _context.next = 34;
                break;
              case 31:
                _context.prev = 31;
                _context.t1 = _context["catch"](24);
                return _context.abrupt("return");
              case 34:
                _context.prev = 34;
                _s();
                return _context.finish(34);
              case 37:
                _context.next = 23;
                break;
              case 39:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[7, 12, 15, 18], [24, 31, 34, 37]]);
        }));
        return function l(_x, _x2) {
          return _ref7.apply(this, arguments);
        };
      }();
    return {
      V: function V(l) {
        n = l, o = L(e, l, t, function () {
          return J(l[i], t);
        }, function (t, n, o) {
          if (o) {
            var _e5 = l.style,
              _t3 = _e5[s];
            _e5[s] = "hidden", B(function () {
              _e5[s] = _t3;
            });
          }
          n ? (l[i] = e.C() + t, r && r()) : l[i] += t;
        });
      },
      X: function X() {
        o && o.P();
      },
      Y: function Y(e) {
        l(function () {
          return e;
        });
      },
      j: function j(t) {
        t += e.C(), l(function () {
          return t;
        });
      },
      q: function q(t) {
        var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          n = _ref8.align,
          o = _ref8.smooth,
          _ref8$offset = _ref8.offset,
          r = _ref8$offset === void 0 ? 0 : _ref8$offset;
        if (t = p(t, 0, e.M() - 1), "nearest" === n) {
          var _o2 = e.T(t),
            _r5 = e.C();
          if (_o2 < _r5) n = "start";else {
            if (!(_o2 + e.R(t) > _r5 + e.v())) return;
            n = "end";
          }
        }
        l(function () {
          return r + e.W() + e.T(t) + ("end" === n ? e.R(t) - e.v() : "center" === n ? (e.R(t) - e.v()) / 2 : 0);
        }, o);
      },
      D: function D() {
        o && o.A();
      }
    };
  },
  A = function A(e, t) {
    var n, o, r;
    var i = function i(e, t, n, o) {
        var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var s = o ? "offsetLeft" : "offsetTop",
          l = r + (o && E() ? n.innerWidth - e[s] - e.offsetWidth : e[s]),
          c = e.offsetParent;
        return e !== t && c ? i(c, t, n, o, l) : l;
      },
      s = /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(o, i) {
          var l, c, _c$scroll, _l2, _l3, _e6, _t4, _l4, _l5, _n4, _r6;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (n) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return", void m(function () {
                  return s(o, i);
                }));
              case 2:
                r && r();
                l = function l() {
                  var t;
                  return [new Promise(function (n, o) {
                    t = n, r = o, W(e) && B(o, 150);
                  }), e.B(2, function () {
                    t && t();
                  })];
                }, c = R(T(n));
                if (!(i && C())) {
                  _context2.next = 23;
                  break;
                }
              case 5:
                if (!(e.J(8, o()), e.k())) {
                  _context2.next = 20;
                  break;
                }
                _l2 = l(), _l3 = _slicedToArray(_l2, 2), _e6 = _l3[0], _t4 = _l3[1];
                _context2.prev = 7;
                _context2.next = 10;
                return _e6;
              case 10:
                _context2.next = 15;
                break;
              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](7);
                return _context2.abrupt("return");
              case 15:
                _context2.prev = 15;
                _t4();
                return _context2.finish(15);
              case 18:
                _context2.next = 5;
                break;
              case 20:
                c.scroll((_c$scroll = {}, _defineProperty(_c$scroll, t ? "left" : "top", J(o(), t)), _defineProperty(_c$scroll, "behavior", "smooth"), _c$scroll));
                _context2.next = 39;
                break;
              case 23:
                _l4 = l(), _l5 = _slicedToArray(_l4, 2), _n4 = _l5[0], _r6 = _l5[1];
                _context2.prev = 24;
                c.scroll(_defineProperty({}, t ? "left" : "top", J(o(), t)));
                e.J(7);
                _context2.next = 29;
                return _n4;
              case 29:
                _context2.next = 34;
                break;
              case 31:
                _context2.prev = 31;
                _context2.t1 = _context2["catch"](24);
                return _context2.abrupt("return");
              case 34:
                _context2.prev = 34;
                _r6();
                return _context2.finish(34);
              case 37:
                _context2.next = 23;
                break;
              case 39:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[7, 12, 15, 18], [24, 31, 34, 37]]);
        }));
        return function s(_x3, _x4) {
          return _ref9.apply(this, arguments);
        };
      }();
    return {
      V: function V(r) {
        n = r;
        var s = t ? "scrollX" : "scrollY",
          l = T(r),
          c = R(l),
          d = l.body;
        o = L(e, c, t, function () {
          return J(c[s], t);
        }, function (n, o) {
          o ? c.scroll(_defineProperty({}, t ? "left" : "top", e.C() + n)) : c.scrollBy(t ? n : 0, t ? 0 : n);
        }, function () {
          return i(r, d, c, t);
        });
      },
      X: function X() {
        o && o.P(), n = void 0;
      },
      D: function D() {
        o && o.A();
      },
      q: function q(o) {
        var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          r = _ref10.align,
          l = _ref10.smooth,
          _ref10$offset = _ref10.offset,
          c = _ref10$offset === void 0 ? 0 : _ref10$offset;
        if (!n) return;
        if (o = p(o, 0, e.M() - 1), "nearest" === r) {
          var _t5 = e.T(o),
            _n5 = e.C();
          if (_t5 < _n5) r = "start";else {
            if (!(_t5 + e.R(o) > _n5 + e.v())) return;
            r = "end";
          }
        }
        var d = T(n),
          f = R(d),
          u = d.documentElement,
          a = function a() {
            return e.v() - (t ? u.clientWidth : u.clientHeight);
          };
        s(function () {
          return c + i(n, d.body, f, t) + e.T(o) + ("end" === r ? e.R(o) - (e.v() - a()) : "center" === r ? (e.R(o) - (e.v() - a())) / 2 : 0);
        }, l);
      }
    };
  },
  V = function V(e, t) {
    var n = P(e, !1),
      o = P(t, !0);
    return {
      V: function V(e) {
        n.V(e), o.V(e);
      },
      X: function X() {
        n.X(), o.X();
      },
      Y: function Y(e, t) {
        n.Y(t), o.Y(e);
      },
      j: function j(e, t) {
        n.j(t), o.j(e);
      },
      q: function q(e, t) {
        n.q(t), o.q(e);
      },
      D: function D() {
        n.D(), o.D();
      }
    };
  },
  X = function X(e) {
    var t;
    return {
      U: function U(n) {
        (t || (t = new (R(T(n)).ResizeObserver)(e))).observe(n);
      },
      F: function F(e) {
        t.unobserve(e);
      },
      P: function P() {
        t && t.disconnect();
      }
    };
  },
  Y = function Y(e, t) {
    var n;
    var o = t ? "width" : "height",
      r = new WeakMap(),
      i = X(function (t) {
        var i = [];
        var _iterator2 = _createForOfIteratorHelper(t),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _step2.value,
              _s2 = _step2$value.target,
              _l6 = _step2$value.contentRect;
            if (_s2.offsetParent) if (_s2 === n) e.J(4, _l6[o]);else {
              var _e7 = r.get(_s2);
              _e7 != f && i.push([_e7, _l6[o]]);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        i.length && e.J(3, i);
      });
    return {
      G: function G(e) {
        i.U(n = e);
      },
      K: function K(e, t) {
        return r.set(e, t), i.U(e), function () {
          r.delete(e), i.F(e);
        };
      },
      X: i.P
    };
  },
  j = function j(e, t) {
    var n = t ? "width" : "height",
      o = t ? "innerWidth" : "innerHeight",
      r = new WeakMap(),
      i = X(function (t) {
        var o = [];
        var _iterator3 = _createForOfIteratorHelper(t),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _step3.value,
              _e8 = _step3$value.target,
              _i3 = _step3$value.contentRect;
            if (!_e8.offsetParent) continue;
            var _t6 = r.get(_e8);
            _t6 != f && o.push([_t6, _i3[n]]);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        o.length && e.J(3, o);
      });
    var s;
    return {
      G: function G(t) {
        var n = R(T(t)),
          r = function r() {
            e.J(4, n[o]);
          };
        n.addEventListener("resize", r), r(), s = function s() {
          n.removeEventListener("resize", r);
        };
      },
      K: function K(e, t) {
        return r.set(e, t), i.U(e), function () {
          r.delete(e), i.F(e);
        };
      },
      X: function X() {
        s && s(), i.P();
      }
    };
  },
  q = function q(e, t) {
    var n;
    var o = "height",
      r = "width",
      i = new WeakMap(),
      s = new Set(),
      l = new Set(),
      c = new Map(),
      d = function d(e, t) {
        return "".concat(e, "-").concat(t);
      },
      f = X(function (f) {
        var u = new Set(),
          h = new Set();
        var _iterator4 = _createForOfIteratorHelper(f),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _step4.value,
              _s3 = _step4$value.target,
              _l7 = _step4$value.contentRect;
            if (_s3.offsetParent) if (_s3 === n) e.J(4, _l7[o]), t.J(4, _l7[r]);else {
              var _e10 = i.get(_s3);
              if (_e10) {
                var _e11 = _slicedToArray(_e10, 2),
                  _t8 = _e11[0],
                  _n6 = _e11[1],
                  _i4 = d(_t8, _n6),
                  _s4 = c.get(_i4),
                  _f = [_l7[o], _l7[r]];
                var _a = void 0,
                  _v = void 0;
                _s4 ? (_s4[0] !== _f[0] && (_a = !0), _s4[1] !== _f[1] && (_v = !0)) : _a = _v = !0, _a && u.add(_t8), _v && h.add(_n6), (_a || _v) && c.set(_i4, _f);
              }
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        if (u.size) {
          var _t7 = [];
          u.forEach(function (e) {
            var n = 0;
            l.forEach(function (t) {
              var o = c.get(d(e, t));
              o && (n = a(n, o[0]));
            }), n && _t7.push([e, n]);
          }), e.J(3, _t7);
        }
        if (h.size) {
          var _e9 = [];
          h.forEach(function (t) {
            var n = 0;
            s.forEach(function (e) {
              var o = c.get(d(e, t));
              o && (n = a(n, o[1]));
            }), n && _e9.push([t, n]);
          }), t.J(3, _e9);
        }
      });
    return {
      G: function G(e) {
        f.U(n = e);
      },
      K: function K(e, t, n) {
        return i.set(e, [t, n]), s.add(t), l.add(n), f.U(e), function () {
          i.delete(e), f.F(e);
        };
      },
      X: f.P
    };
  },
  D = z ? t : n,
  U = "current",
  F = function F(e, t) {
    if (Array.isArray(e)) {
      var _iterator5 = _createForOfIteratorHelper(e),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _n7 = _step5.value;
          F(_n7, t);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    } else null == e || "boolean" == typeof e || t.push(e);
  },
  G = function G(e, t) {
    var n = e.key;
    return null != n ? n : "_" + t;
  },
  K = function K(e) {
    var t = o();
    return t[U] || (t[U] = e());
  },
  N = function N(e) {
    var t = o(e);
    return D(function () {
      t[U] = e;
    }, [e]), t;
  },
  Q = /*#__PURE__*/r(function (_ref11) {
    var t = _ref11.N,
      n = _ref11.Z,
      r = _ref11.ee,
      s = _ref11.te,
      l = _ref11.ne,
      c = _ref11.oe,
      d = _ref11.re,
      f = _ref11.ie;
    var u = o(null);
    D(function () {
      return n(u[U], r);
    }, [r]);
    var a = i(function () {
      var _e12;
      var e = (_e12 = {
        position: l && f ? void 0 : "absolute"
      }, _defineProperty(_e12, d ? "height" : "width", "100%"), _defineProperty(_e12, d ? "top" : "left", 0), _defineProperty(_e12, d ? E() ? "right" : "left" : "top", s), _defineProperty(_e12, "visibility", !l || f ? "visible" : "hidden"), _e12);
      return d && (e.display = "flex"), e;
    }, [s, l, f, d]);
    return e(c, "string" == typeof c ? {
      ref: u,
      style: a,
      children: t
    } : {
      ref: u,
      style: a,
      index: r,
      children: t
    });
  }),
  Z = function Z(e, t) {
    return i(function () {
      if ("function" == typeof e) return [e, t || 0];
      var n = function (e) {
        var t = [];
        return F(e, t), t;
      }(e);
      return [function (e) {
        return n[e];
      }, n.length];
    }, [e, t]);
  },
  ee = /*#__PURE__*/s(function (_ref12, y) {
    var t = _ref12.children,
      n = _ref12.count,
      r = _ref12.overscan,
      i = _ref12.itemSize,
      s = _ref12.shift,
      f = _ref12.horizontal,
      u = _ref12.keepMounted,
      a = _ref12.cache,
      _ref12$startMargin = _ref12.startMargin,
      h = _ref12$startMargin === void 0 ? 0 : _ref12$startMargin,
      v = _ref12.ssrCount,
      _ref12$as = _ref12.as,
      p = _ref12$as === void 0 ? "div" : _ref12$as,
      _ref12$item = _ref12.item,
      _ = _ref12$item === void 0 ? "div" : _ref12$item,
      w = _ref12.scrollRef,
      S = _ref12.onScroll,
      $ = _ref12.onScrollEnd;
    var _Z = Z(t, n),
      _Z2 = _slicedToArray(_Z, 2),
      x = _Z2[0],
      b = _Z2[1],
      I = o(null),
      z = o(!!v),
      k = N(S),
      T = N($),
      _K = K(function () {
        var e = !!f,
          t = O(b, i, r, v, a, !i);
        return [t, Y(t, e), P(t, e), e];
      }),
      _K2 = _slicedToArray(_K, 4),
      R = _K2[0],
      E = _K2[1],
      M = _K2[2],
      C = _K2[3];
    b !== R.M() && R.J(5, [b, s]), h !== R.W() && R.J(6, h);
    var _l8 = l(R.p, void 0, R.p),
      _l9 = _slicedToArray(_l8, 2),
      W = _l9[0],
      B = _l9[1],
      _R$_ = R._(),
      _R$_2 = _slicedToArray(_R$_, 2),
      J = _R$_2[0],
      L = _R$_2[1],
      A = R.H(),
      V = R.h(),
      X = [],
      j = function j(t) {
        var n = x(t);
        return e(Q, {
          Z: E.K,
          ee: t,
          te: R.T(t),
          ne: R.I(t),
          oe: _,
          N: n,
          re: C,
          ie: z[U]
        }, G(n, t));
      };
    D(function () {
      z[U] = !1;
      var e = R.B(1, function (e) {
          e ? d(B) : B();
        }),
        t = R.B(4, function () {
          k[U] && k[U](R.C());
        }),
        n = R.B(8, function () {
          T[U] && T[U]();
        }),
        o = function o(e) {
          E.G(e), M.V(e);
        };
      return w ? m(function () {
        return o(w[U]);
      }) : o(I[U].parentElement), function () {
        e(), t(), n(), E.X(), M.X();
      };
    }, []), D(function () {
      M.D();
    }, [W]), c(y, function () {
      return {
        get cache() {
          return R.m();
        },
        get scrollOffset() {
          return R.C();
        },
        get scrollSize() {
          return H(R);
        },
        get viewportSize() {
          return R.v();
        },
        findStartIndex: R.S,
        findEndIndex: R.$,
        getItemOffset: R.T,
        getItemSize: R.R,
        scrollToIndex: M.q,
        scrollTo: M.Y,
        scrollBy: M.j
      };
    }, []);
    for (var _e13 = J, _t9 = L; _e13 <= _t9; _e13++) X.push(j(_e13));
    if (u) {
      var _e14 = [],
        _t10 = [];
      g(u).forEach(function (n) {
        n < J && _e14.push(j(n)), n > L && _t10.push(j(n));
      }), X.unshift.apply(X, _e14), X.push.apply(X, _t10);
    }
    return e(p, {
      ref: I,
      style: {
        overflowAnchor: "none",
        flex: "none",
        position: "relative",
        visibility: "hidden",
        width: C ? V : "100%",
        height: C ? "100%" : V,
        pointerEvents: A ? "none" : void 0
      },
      children: X
    });
  }),
  te = /*#__PURE__*/s(function (_ref13, m) {
    var _objectSpread2;
    var t = _ref13.children,
      n = _ref13.count,
      r = _ref13.overscan,
      i = _ref13.itemSize,
      s = _ref13.shift,
      l = _ref13.horizontal,
      c = _ref13.keepMounted,
      d = _ref13.reverse,
      f = _ref13.cache,
      u = _ref13.ssrCount,
      a = _ref13.item,
      h = _ref13.onScroll,
      v = _ref13.onScrollEnd,
      p = _ref13.style,
      g = _objectWithoutProperties(_ref13, _excluded);
    var _ = o(null),
      w = d && !l;
    var S = e(ee, {
      ref: m,
      scrollRef: w ? _ : void 0,
      count: n,
      overscan: r,
      itemSize: i,
      shift: s,
      horizontal: l,
      keepMounted: c,
      cache: f,
      ssrCount: u,
      item: a,
      onScroll: h,
      onScrollEnd: v,
      children: t
    });
    return w && (S = e("div", {
      style: {
        visibility: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        minHeight: "100%"
      },
      children: S
    })), e("div", _objectSpread(_objectSpread({
      ref: _
    }, g), {}, {
      style: _objectSpread((_objectSpread2 = {
        display: l ? "inline-block" : "block"
      }, _defineProperty(_objectSpread2, l ? "overflowX" : "overflowY", "auto"), _defineProperty(_objectSpread2, "contain", "strict"), _defineProperty(_objectSpread2, "width", "100%"), _defineProperty(_objectSpread2, "height", "100%"), _objectSpread2), p),
      children: S
    }));
  }),
  ne = /*#__PURE__*/s(function (_ref14, m) {
    var t = _ref14.children,
      n = _ref14.count,
      r = _ref14.overscan,
      i = _ref14.itemSize,
      s = _ref14.shift,
      f = _ref14.horizontal,
      u = _ref14.cache,
      a = _ref14.ssrCount,
      _ref14$as = _ref14.as,
      h = _ref14$as === void 0 ? "div" : _ref14$as,
      _ref14$item = _ref14.item,
      v = _ref14$item === void 0 ? "div" : _ref14$item,
      p = _ref14.onScroll,
      g = _ref14.onScrollEnd;
    var _Z3 = Z(t, n),
      _Z4 = _slicedToArray(_Z3, 2),
      _ = _Z4[0],
      w = _Z4[1],
      S = o(null),
      $ = N(p),
      y = N(g),
      x = o(!!a),
      _K3 = K(function () {
        var e = !!f,
          t = O(w, i, r, a, u, !i);
        return [t, j(t, e), A(t, e), e];
      }),
      _K4 = _slicedToArray(_K3, 4),
      b = _K4[0],
      I = _K4[1],
      z = _K4[2],
      k = _K4[3];
    w !== b.M() && b.J(5, [w, s]);
    var _l10 = l(b.p, void 0, b.p),
      _l11 = _slicedToArray(_l10, 2),
      T = _l11[0],
      R = _l11[1],
      _b$_ = b._(),
      _b$_2 = _slicedToArray(_b$_, 2),
      E = _b$_2[0],
      M = _b$_2[1],
      C = b.H(),
      H = b.h(),
      W = [];
    D(function () {
      x[U] = !1;
      var e = b.B(1, function (e) {
          e ? d(R) : R();
        }),
        t = b.B(4, function () {
          $[U] && $[U]();
        }),
        n = b.B(8, function () {
          y[U] && y[U]();
        }),
        o = S[U];
      return I.G(o), z.V(o), function () {
        e(), t(), n(), I.X(), z.X();
      };
    }, []), D(function () {
      z.D();
    }, [T]), c(m, function () {
      return {
        get cache() {
          return b.m();
        },
        findStartIndex: b.S,
        findEndIndex: b.$,
        scrollToIndex: z.q
      };
    }, []);
    for (var _t11 = E, _n8 = M; _t11 <= _n8; _t11++) {
      var _n9 = _(_t11);
      W.push(e(Q, {
        Z: I.K,
        ee: _t11,
        te: b.T(_t11),
        ne: b.I(_t11),
        oe: v,
        N: _n9,
        re: k,
        ie: x[U]
      }, G(_n9, _t11)));
    }
    return e(h, {
      ref: S,
      style: {
        flex: "none",
        position: "relative",
        visibility: "hidden",
        width: k ? H : "100%",
        height: k ? "100%" : H,
        pointerEvents: C ? "none" : void 0
      },
      children: W
    });
  }),
  oe = function oe(e, t) {
    return "".concat(e, "-").concat(t);
  },
  re = /*#__PURE__*/r(function (_ref15) {
    var t = _ref15.N,
      n = _ref15.Z,
      r = _ref15.se,
      s = _ref15.le,
      l = _ref15.ce,
      c = _ref15.de,
      d = _ref15.fe,
      f = _ref15.ue,
      u = _ref15.ne,
      a = _ref15.ae;
    var h = o(null);
    return D(function () {
      return n.K(h[U], r, s);
    }, [s, r]), e(a, {
      ref: h,
      style: i(function () {
        var _ref16;
        return _ref16 = {
          display: "grid",
          position: "absolute",
          top: l
        }, _defineProperty(_ref16, E() ? "right" : "left", c), _defineProperty(_ref16, "visibility", u ? "hidden" : "visible"), _defineProperty(_ref16, "minHeight", d), _defineProperty(_ref16, "minWidth", f), _ref16;
      }, [l, c, f, d, u]),
      children: t
    });
  }),
  ie = /*#__PURE__*/s(function (_ref17, w) {
    var t = _ref17.children,
      n = _ref17.row,
      r = _ref17.col,
      _ref17$cellHeight = _ref17.cellHeight,
      s = _ref17$cellHeight === void 0 ? 40 : _ref17$cellHeight,
      _ref17$cellWidth = _ref17.cellWidth,
      f = _ref17$cellWidth === void 0 ? 100 : _ref17$cellWidth,
      _ref17$overscan = _ref17.overscan,
      u = _ref17$overscan === void 0 ? 2 : _ref17$overscan,
      a = _ref17.initialRowCount,
      h = _ref17.initialColCount,
      _ref17$item = _ref17.item,
      v = _ref17$item === void 0 ? "div" : _ref17$item,
      p = _ref17.onScroll,
      g = _ref17.onScrollEnd,
      m = _ref17.style,
      _ = _objectWithoutProperties(_ref17, _excluded2);
    var _K5 = K(function () {
        var e = O(n, s, u, a),
          t = O(r, f, u, h);
        return [e, t, q(e, t), V(e, t)];
      }),
      _K6 = _slicedToArray(_K5, 4),
      S = _K6[0],
      $ = _K6[1],
      y = _K6[2],
      x = _K6[3];
    n !== S.M() && S.J(5, [n]), r !== $.M() && $.J(5, [r]);
    var _l12 = l(S.p, void 0, S.p),
      _l13 = _slicedToArray(_l12, 2),
      b = _l13[0],
      I = _l13[1],
      _l14 = l($.p, void 0, $.p),
      _l15 = _slicedToArray(_l14, 2),
      z = _l15[0],
      k = _l15[1],
      _S$_ = S._(),
      _S$_2 = _slicedToArray(_S$_, 2),
      T = _S$_2[0],
      R = _S$_2[1],
      _$$_ = $._(),
      _$$_2 = _slicedToArray(_$$_, 2),
      E = _$$_2[0],
      M = _$$_2[1],
      C = S.H(),
      W = $.H(),
      B = H(S),
      J = H($),
      L = o(null),
      P = N(p),
      A = N(g);
    D(function () {
      var e = L[U],
        t = S.B(1, function (e) {
          e ? d(I) : I();
        }),
        n = $.B(1, function (e) {
          e ? d(k) : k();
        }),
        o = S.B(4, function () {
          P[U] && P[U](S.C());
        }),
        r = S.B(8, function () {
          A[U] && A[U]();
        });
      return y.G(e), x.V(e), function () {
        t(), n(), y.X(), x.X(), o(), r();
      };
    }, []), D(function () {
      x.D();
    }, [b, z]), c(w, function () {
      return {
        get scrollTop() {
          return S.C();
        },
        get scrollLeft() {
          return $.C();
        },
        get scrollHeight() {
          return H(S);
        },
        get scrollWidth() {
          return H($);
        },
        get viewportHeight() {
          return S.v();
        },
        get viewportWidth() {
          return $.v();
        },
        findStartIndex: function findStartIndex() {
          return [$.S(), S.S()];
        },
        findEndIndex: function findEndIndex() {
          return [$.$(), S.$()];
        },
        getItemOffset: function getItemOffset(e, t) {
          return [$.T(e), S.T(t)];
        },
        getItemSize: function getItemSize(e, t) {
          return [$.R(e), S.R(t)];
        },
        scrollToIndex: x.q,
        scrollTo: x.Y,
        scrollBy: x.j
      };
    }, []);
    var X = i(function () {
        var e = new Map();
        return function (n, o) {
          var r = e.get(oe(n, o));
          return r || e.set(oe(n, o), r = t({
            rowIndex: n,
            colIndex: o
          })), r;
        };
      }, [t]),
      Y = [];
    for (var _t12 = T; _t12 <= R; _t12++) for (var _n10 = E; _n10 <= M; _n10++) Y.push(e(re, {
      Z: y,
      se: _t12,
      le: _n10,
      ce: S.T(_t12),
      de: $.T(_n10),
      fe: S.R(_t12),
      ue: $.R(_n10),
      ne: S.I(_t12) || $.I(_n10),
      ae: v,
      N: X(_t12, _n10)
    }, oe(_t12, _n10)));
    return e("div", _objectSpread(_objectSpread({
      ref: L
    }, _), {}, {
      style: _objectSpread({
        overflow: "auto",
        contain: "strict",
        width: "100%",
        height: "100%"
      }, m),
      children: e("div", {
        style: {
          overflowAnchor: "none",
          flex: "none",
          position: "relative",
          visibility: "hidden",
          width: J,
          height: B,
          pointerEvents: C || W ? "none" : void 0
        },
        children: Y
      })
    }));
  });
export { te as VList, ee as Virtualizer, ne as WindowVirtualizer, ie as experimental_VGrid };